import get from '../getService'
import URL from '../../Constants/apiUrls'

export default function searchInUserList(urlParameters) {
  return new Promise((resolve, reject) => {
    var url = URL.searchInUserList + urlParameters
    get(url)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
